import { INIT_VAST_SAMPLE } from './Labels';

/**
 * Config server URL (prod)
 * @readonly
 * @static
 * @type {string}
 */
export const configServerProdUrl = 'https://showcaseconfig.smartadserverapis.com/config';

/**
 * Config server URL (local)
 * @readonly
 * @static
 * @type {string}
 */
export const configServerLocalUrl = 'http://localhost:3001/config';

/**
 * Maximum string length
 */
export const MAX_SHARE_URL_LENGTH = 75;

/**
 * The collection of JWPlayer possible states
 * @readonly
 * @static
 * @type {Object}
 */
export const jwPlayerStates = {
  IDLE: 'idle',
};

/**
 * The collection of active tab indexes
 * @readonly
 * @static
 * @type {Object}
 */
export const sections = {
  VAST_INSPECTOR: 0,
  PLUGIN_SETTINGS: 1,
  OUTPUT: 2,
};

/**
 * The initial state object
 * @property {Number} activeSection the index of the active tab
 * @property {Array} logs Array of logs from controller
 * @property {Object} adData the placementData state
 * @property {Boolean} adData.isValid the variable claiming if the placement data is valid
 * @property {Number|String of Numbers separated by ","} adData.sas_format_linears the linear format ID or ids
 * @property {Number} adData.sas_format_overlays the format ID
 * @property {Number} adData.sas_networkid the network ID
 * @property {Number} adData.sas_pageid the page ID
 * @property {Number} adData.sas_siteid the site ID
 * @property {String} adData.sas_target the target string
 * @property {Object} player The player's state
 * @property {Boolean} player.autoplay The value of the autoplay attribute
 * @property {String} player.containerId The id of the player's container tag
 * @property {String} player.name The name of the selected player
 * @property {Number} player.version The version of the selected player
 * @property {Number} subTab the sub tab index
 * @property {String} vastSource The vast source
 * @readonly
 * @static
 * @type {Object}
 */
export const initStateObj = {
  activeSection: sections.VAST_INSPECTOR,
  adData: {
    isValid: true,
    sas_format_linears: '27153',
    sas_format_overlays: '27154',
    sas_networkid: '73',
    sas_pageid: '322652',
    sas_siteid: '44928',
    sas_target: '',
  },
  adRules: {
    data: [
      {
        duration_min: 0,
        duration_max: -1,
        data: {
          prerolls: {
            instances: 1,
            maxAdPodDuration: 0,
          },
          overlays: {
            instances: 1,
            interval: null,
            offset: null,
            percents: [10],
            timecodes: [],
          },
          midrolls: {
            instances: 0,
            interval: null,
            offset: null,
            percents: [],
            timecodes: [],
            maxAdPodDuration: 0,
          },
          postrolls: {
            instances: 0,
            maxAdPodDuration: 0,
          },
        },
      },
    ],
    isValid: true,
  },
  configuration: {
    isValid: true,
    labels: {
      lbl_countdown_break_midroll: {
        EN: 'Your content will resume in {0}',
      },
      lbl_countdown_break_postroll: {
        EN: 'End of ad break in {0}',
      },
      lbl_countdown_break_preroll: {
        EN: 'Your content will start in {0}',
      },
      lbl_countdown_skip: {
        EN: 'You can skip this ad in {0} seconds',
      },
      lbl_more: {
        EN: 'More...',
      },
      lbl_skip_vpaid: {
        EN: 'You can skip this interactive ad',
      },
    },
    overlays: {
      hideDuringPause: true,
      resize: true,
    },
    companions: {
      remove: true,
      slot: 'testCompanion',
    },
    banner: {
      sas_format_banners: '',
      sas_target_banners: '',
    },
    player: {
      autoHideControls: true,
      controlBarMode: 'CONTROL_BAR_MODE_FLOATING',
      enableCountdownSkip: true,
      enableCountdownVideo: true,
      enableFullscreen: true,
      enablePause: false,
      enableSound: true,
      scaleMode: 'SCALE_MODE_LETTERBOX',
    },
    publisher: {
      activeControlsForEmbededAdManager: true,
      allowConditionalAd: true,
      bumperDuration: 0,
      bumperPreAdUrl: '',
      bumperPostAdUrl: '',
      checkUniversalAdId: false,
      countdownTimeFormat: 'mm:ss',
      enableAdPauseOnWindowChange: true,
      enableMobileClickThroughButton: false,
      forceSkipDelay: false,
      html5SeamlessFullscreen: false,
      integralAdScienceAnId: '-1',
      loadHlsJsLibrary: false,
      muteAdsAtStartup: false,
      numberOfPassbackAds: '-1',
      numMaxRedirect: '5',
      pauseMainContentUntilVASTIsLoaded: true,
      replayAd: true,
      requestTimeout: '3',
      skipDelay: '10',
      totalTimeout: '8',
      unmuteOnMouseOver: false,
      visibilityThresholdForPlayback: '-1',
      visibilityThresholdForUnmute: '-1',
      enableSSAR: false,
      schain: '',
      vpaidFirst: false,
    },
    rtb: {
      vdmin: '',
      vdmax: '',
      vbrmin: '',
      vbrmax: '',
      vpmt: '',
      pgDomain: '',
    },
    vpaid: {
      enableCountdownVideo: true,
      enableSkip: true,
      enableSkipLabel: true,
      generalTimeout: '3',
      handleSkipOffset: false,
      initTimeout: '3',
      loadTimeout: '3',
      totalTimeout: '5',
    },
  },
  other: {
    isValid: true,
    content: {
      sas_contentid: '',
      sas_videoContentDuration: null,
    },
    user: {
      uid: '',
    },
  },
  logs: [],
  player: {
    autoplay: false,
    containerId: 'container',
    name: 'jwplayer',
    version: '7.9.0',
  },
  subTab: 0,
  vastSource: '',
  vastSample: INIT_VAST_SAMPLE,
  importPopupOpen: false,
  companionWidth: 300,
  companionHeight: 250,
  configurationUrl: {
    loading: false,
    value: '',
  },
};

/**
 * The property which identifies whether current device is mobile one or not
 */
export const isMobile = (function () {
  let userAgent = globalThis.navigator.userAgent.toLocaleLowerCase(),
    ua = userAgent || globalThis.navigator.vendor || globalThis.opera;

  const mobileRegex1 =
    /(android|bb\d+|meego).+?gt|sm|mobile|nexus|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(ad|hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+?firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/;

  const mobileRegex2 =
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/;

  return mobileRegex1.test(ua) || mobileRegex2.test(ua.substr(0, 4));
})();

/**
 * Detects if device is iPhone
 */
export const isIPhone = (function () {
  return /ip(hone|od)/.test(globalThis.navigator.userAgent.toLowerCase());
})();
/**
 * Detects if device is iPad
 */
export const isIPad = (function () {
  return /ipad/.test(globalThis.navigator.userAgent.toLowerCase());
})();

/**
 * The dictionary with detailed informations for Vast Inspctor logs
 * @readonly
 * @static
 * @type {Object}
 */
export const LogsDetailsDictionary = {
  ADPOD_COMPLETED: 'has finished',
  'integral-blocked': 'ad was blocked by Integral Ad Science',
  'total-timeout': 'total timeout occurred',
  undefined: '',
  'vast-undefined-error': '',
  // Error log details
  10000001: 'details of error: VAST can not be loaded',
  10000002: 'details of error: timeout occurred during vast loading',
  10000201: 'details of error: format was blocked',
  10000401: 'details of error: a timeout occurred for Integral Ad Science',
  10000301: 'details of error: universal ad id was rejected',
  101401: 'details of error: missing duration in vast',
  100001: 'details of error 100: XML parsing error',
  101001: 'details of error 101: not defined vast version',
  101002: 'details of error 101: missing AdSystem tag in vast',
  101003: 'details of error 101: missing AdTitile tag in vast',
  101004: 'details of error 101: missing Impression in vast',
  101005: 'details of error 101: not valid Inline and Wrapper tag in vast',
  101007: 'details of error 101: missing Creatives tag in vast',
  101501: 'details of error 101: nonlinear missing attributes',
  101502: 'details of error 101: nonlinear missing resources',
  102001: 'details of error 102: VAST version not supported',
  102002: 'details of error 102: wrapper version not supported',
  201001: 'details of error 201: mismatched ad linearity',
  206001: 'details of error 206: ad duration is bigger than allowed duration ',
  301001: 'details of error 301: wrapper can not be loaded',
  301003: 'details of error 301: timeout occurred during wrapper loading',
  301004: 'details of error 301: wrapper url not defined',
  304001:
    'details of error 304: InLine response returned ad unit that failed to result in ad display within defined time limit',
  302001: 'details of error 302: reached max number of wrapper calls',
  303001: 'details of error 303: no VAST response after one or more Wrappers',
  303002: 'details of error 303: wrapper parsing error',
  408001: 'details of error 408: conditional ad was rejected',
  400001: 'details of error 400: general linear error',
  401002: 'details of error 401: missing media files in vast',
  409001: 'details of error 409: interactive creative file not executed',
  402001: 'details of error 402: timeout occurred during ad loading',
  403001: 'details of error 403: there is no media format, that could be play',
  502001: 'details of error 502: The nonlinear creative can not be loaded because of an HTTP Error',
  501001:
    'details of error 501: the size (w/h) of the nonlinear creative is bigger than the player size',
  503001: 'details of error 503: no nonlinear resource format',
  603001: 'details of error 603: companion can not be loaded',
  600001: 'details of error 600: general companion error',
  602: 'details of error 602: unable to display required companion ads',
  604001: 'details of error 604: no companion resource format',
  901001: 'details of error 901: report general VPAID error',
  901002: 'details of error 901: vpaid fetch error',
  901003: 'details of error 901: vpaid playback error',
};

/**
 * The dictionary for Vast Inspctor logs
 * @readonly
 * @static
 * @type {Object}
 */
export const LogsDictionary = {
  acceptInvitation: 'Ad event: acceptInvitation',
  AdClickThru: 'Ad event: AdClickThru',
  AdDurationChange: 'Ad event: AdDurationChange',
  AdError: 'Ad event: AdError, ',
  AdExpandedChange: 'Ad event: AdExpandedChange',
  AdInteraction: 'Ad event: AdInteraction',
  AdImpression: 'Ad event: AdImpression',
  AdLinearChange: 'Ad event: AdLinearChange',
  AdLoaded: 'Ad event: AdLoaded',
  AdLog: 'Ad event: AdLog',
  AdPaused: 'Ad event: AdPaused',
  AdPlaying: 'Ad event: AdPlaying',
  AdRemainingTimeChange: 'Ad event: AdRemainingTimeChange',
  AdSizeChange: 'Ad event: AdSizeChange',
  AdSkippableStateChange: 'Ad event: AdSkippableStateChange',
  AdSkipped: 'Ad event: AdSkipped',
  AdStarted: 'Ad event: AdStarted',
  AdStopped: 'Ad event: AdStopped',
  AdUserAcceptInvitation: 'Ad event: AdUserAcceptInvitation',
  AdUserClose: 'Ad event: AdUserClose',
  AdUserMinimize: 'Ad event: AdUserMinimize',
  AdVideoComplete: 'Ad event: AdVideoComplete',
  AdVideoFirstQuartile: 'Ad event: AdVideoFirstQuartile',
  AdVideoMidpoint: 'Ad event: AdVideoMidpoint',
  AdVideoStart: 'Ad event: AdVideoStart',
  AdVideoThirdQuartile: 'Ad event: AdVideoThirdQuartile',
  AdVolumeChange: 'Ad event: AdVolumeChange',
  click: 'Ad event: click',
  close: 'Ad event: close',
  collapse: 'Ad event: collapse',
  complete: 'Ad event: complete',
  creativeView: 'Ad event: creativeView',
  error: 'Ad error',
  executeAd: 'Ad started',
  expand: 'Ad event: expand',
  firstQuartile: 'Ad event: firstQuartile',
  generalError: 'An Error happened, ',
  impressionLogged: 'All impressions were successfully logged',
  loaded: 'Ad event: loaded',
  loadPassback: 'Load passback ad',
  midpoint: 'Ad event: midpoint',
  mute: 'Ad event: mute',
  parserLog: 'Vast parsing phase ',
  parserLogError: 'Vast parsing error, ',
  pause: 'Ad event: pause',
  playerCollapse: 'Ad event: playerCollapse',
  playerExpand: 'Ad event: playerExpand',
  progress: 'Ad event: progress',
  resume: 'Ad event: resume',
  rewind: 'Ad event: rewind',
  skip: 'Ad event: skip',
  start: 'Ad event: start',
  startExecutingCuePoint: 'Ad break begun - request for ad',
  stopExecutingCuePoint: 'Ad break ended',
  thirdQuartile: 'Ad event: thirdQuartile',
  unmute: 'Ad event: unmute',
  viewabilityCreateOrUpdate: '',
  viewabilityStartOrStop: '',
};

/**
 * The list of implemented players
 * @readonly
 * @static
 * @type {Object}
 */
export const players = {
  flowplayer: {
    name: 'Flowplayer',
    versions: ['6.0.3', '7.2.1'],
    libLinks: {
      '6.0.3': [
        '//ced-ns.sascdn.com/video/players/flowplayer/6.0.3/flowplayer.min.js',
        '//ced-ns.sascdn.com/video/players/flowplayer/6.0.3/skin/functional.css',
      ],
      '7.2.1': [
        '//ced-ns.sascdn.com/video/players/flowplayer/7.2.1/flowplayer.min.js',
        '//ced-ns.sascdn.com/video/players/flowplayer/7.2.1/skin/skin.css',
      ],
    },
  },
  jwplayer: {
    name: 'JW Player',
    versions: ['7.9.0'], //, '8.5.6'],
    libLinks: {
      '7.9.0': ['//ced-ns.sascdn.com/video/players/jwplayer/7.9.0/jwplayer.js'],
      //'8.5.6': ['//content.jwplatform.com/libraries/FnsUd6H3.js']
    },
  },
  videoTag: {
    name: 'Simple Video tag',
    versions: [],
  },
};

/**
 * The list of sample players
 * @readonly
 * @static
 * @type {Object}
 */
export const samplePlayers = {
  flowplayer: {
    name: 'flowplayer',
    versions: ['5.4.6', '6.0.3', '7.2.1'],
    libLinks: {
      '5.4.6': [
        '//ced-ns.sascdn.com/video/players/flowplayer/5.4.6/flowplayer.min.js',
        '//ced-ns.sascdn.com/video/players/flowplayer/5.4.6/skin/minimalist.css',
        '//ajax.googleapis.com/ajax/libs/jquery/1.8/jquery.min.js',
      ],
      '6.0.3': [
        '//ced-ns.sascdn.com/video/players/flowplayer/6.0.3/flowplayer.min.js',
        '//ced-ns.sascdn.com/video/players/flowplayer/6.0.3/skin/functional.css',
      ],
      '7.2.1': [
        '//ced-ns.sascdn.com/video/players/flowplayer/7.2.1/flowplayer.min.js',
        '//ced-ns.sascdn.com/video/players/flowplayer/7.2.1/skin/skin.css',
      ],
    },
    default: '7.2.1',
  },
  jwplayer: {
    name: 'jwplayer',
    versions: ['5.10', '6.12', '7.9.0', '8.5.6'],
    libLinks: {
      '5.10': ['//ced-ns.sascdn.com/video/players/jwplayer/5.10/jwplayer.js'],
      6.12: ['//ced-ns.sascdn.com/video/players/jwplayer/6.12/jwplayer.js'],
      '7.9.0': ['//ced-ns.sascdn.com/video/players/jwplayer/7.9.0/jwplayer.js'],
      '8.5.6': ['//content.jwplatform.com/libraries/FnsUd6H3.js'],
    },
    default: '8.5.6',
  },
  videoTag: {
    name: 'video',
    versions: ['0'],
    default: '0',
  },
  ooyala: {
    name: 'ooyala',
    versions: [],
    libLinks: {
      v3: ['//player.ooyala.com/v3/13322a7f703043579116cd2dbd5536d7?platform=html5'],
    },
    default: 'v3',
  },
  brightcove: {
    name: 'brightcove',
    versions: ['5', '6'],
    libLinks: {
      5: ['//players.brightcove.net/2436837446001/V1TJ1ahCg_default/index.min.js'],
      6: [],
    },
    default: '6',
  },
};
/**
 * The min height of sample player, for thoses player which cannot work with 100%
 * @readonly
 * @static
 * @type {String}
 */
export const samplesMinPlayerHeight = '360px';

/**
 * The list of playable resources
 * @readonly
 * @static
 * @type {Array}
 */
export const playlist = [
  {
    image: '//ak-ns.sascdn.com/video/movies/samples/short_content_poster.png',
    sources: [
      {
        file: '//ak-ns.sascdn.com/video/movies/samples/short_content.mp4',
        label: 'quality_label',
        type: 'mp4',
      },
      {
        file: '//ak-ns.sascdn.com/video/movies/samples/short_content.webm',
        label: 'quality_label',
        type: 'webm',
      },
    ],
    title: 'Big Buck Bunny',
  },
];

/**
 * The list of playable resources for jwplayer version 5
 * @readonly
 * @static
 * @type {Array}
 */
export const playlistJW5 = {
  levels: [
    {
      file: '//ak-ns.sascdn.com/video/movies/samples/short_content.mp4',
      type: 'video/mp4',
    },
    {
      file: '//ak-ns.sascdn.com/video/movies/samples/short_content.webm',
      type: 'video/webm',
    },
  ],
  image:
    globalThis.location.protocol +
    '//ak-ns.sascdn.com/video/movies/samples/short_content_poster.png',
};

/**
 * The list of VAST samples
 * @readonly
 * @static
 * @type {Object}
 */
export const vastSamples = {
  'Inline Linear Skippable':
    'https://videoapi.smartadserver.com/ac?siteid=384933&pgid=1909569&fmtid=60474&vrn=2023-11-14T09%3A44%3A03%2B00%3A00&ab=1&tgt=sample%3DInlineLinearSkippable&vcn=h&out=vast4&oc=1&ps=1&visit=S&tmstp=1700142491906&vpaidt=js&vpaidv=2&vpmt=-1&pgDomain=https%3A%2F%2Fvideo.smartadserver.com%2F&vit=1&vct=2&vph=231&vpw=412&ctid=12&ctd=123&ssar=0&uid=232323&iabframeworks=7&omidpn=Smartadserver1&omidpv=1.0.0',
  'Wrapper Linear Skippable':
    'https://videoapi.smartadserver.com/ac?siteid=384933&pgid=1909569&fmtid=60474&vrn=2023-11-14T09%3A44%3A03%2B00%3A00&ab=1&tgt=sample%3DWrapperLinearSkippable&vcn=h&out=vast4&oc=1&ps=1&visit=S&tmstp=1700233520048&vpaidt=js&vpaidv=2&vpmt=-1&pgDomain=https%3A%2F%2Fvideo.smartadserver.com%2F&vit=1&vct=2&vph=467&vpw=834&ctid=12&ctd=123&ssar=0&uid=232323&iabframeworks=7&omidpn=Smartadserver1&omidpv=1.0.0',
  'Wrapper Linear Error':
    'https://videoapi.smartadserver.com/ac?siteid=384933&pgid=1909569&fmtid=60474&vrn=2023-11-14T09%3A44%3A03%2B00%3A00&ab=1&tgt=sample%3DWrapperLinearError&vcn=h&out=vast4&oc=1&ps=1&visit=S&tmstp=1700233908777&vpaidt=js&vpaidv=2&vpmt=-1&pgDomain=https%3A%2F%2Fvideo.smartadserver.com%2F&vit=1&vct=2&vph=467&vpw=834&ctid=12&ctd=123&ssar=0&uid=232323&iabframeworks=7&omidpn=Smartadserver1&omidpv=1.0.0',
  'Inline Linear OMSDK':
    'https://videoapi.smartadserver.com/ac?siteid=384933&pgid=1909569&fmtid=60474&vrn=2023-11-14T09%3A44%3A03%2B00%3A00&ab=1&tgt=sample%3DInlineLinearOMSDK&vcn=h&out=vast4&oc=1&ps=1&visit=S&tmstp=1700472343519&vpaidt=js&vpaidv=2&vpmt=-1&pgDomain=https%3A%2F%2Fvideo.smartadserver.com%2F&vit=1&vct=2&vph=279&vpw=498&ctid=12&ctd=123&ssar=0&uid=232323&iabframeworks=7&omidpn=Smartadserver1&omidpv=1.0.0',
  'Inline Linear VPAID 2.0':
    'https://videoapi.smartadserver.com/ac?siteid=384933&pgid=1909569&fmtid=60474&vrn=2023-11-14T09%3A44%3A03%2B00%3A00&ab=1&tgt=sample%3DInlineLinearVpaid20&vcn=h&out=vast4&oc=1&ps=1&visit=S&tmstp=1700472343519&vpaidt=js&vpaidv=2&vpmt=-1&pgDomain=https%3A%2F%2Fvideo.smartadserver.com%2F&vit=1&vct=2&vph=279&vpw=498&ctid=12&ctd=123&ssar=0&uid=232323&iabframeworks=7&omidpn=Smartadserver1&omidpv=1.0.0',
};
